import React, {useEffect, useRef} from "react";
import css from './block1Card2.module.scss'
import {observer} from "mobx-react";
import classNames from "classnames";
import {makeAutoObservable} from "mobx";
import * as Api from "api/api";
import {allGoodsImg} from "api/api";
import Swiper from "swiper";
import GoodsType, {goodsTypeEnumMap} from "enum/GoodsType";
import MyRouter from "router/router";
import NewsMenuType from "enum/NewsMenuType";
import {useHistory} from "react-router-dom";
import MyRouterUtil from "../../utils/MyRouterUtil";
import {DateTime} from "luxon";

class SecKillStore {

    list = []

    startTime = undefined
    endTime = undefined
    hourNumber = 0
    minuteNumber = 0
    secondNumber = 0

    get secKillTimeStr() {
        return this.startTime?.toFormat('HH:mm')
    }

    setStartTime(value) {
        this.startTime = value
    }

    setHourNumber(value) {
        this.hourNumber = value
    }

    get hourNumberStr() {
        return `${this.hourNumber}`.padStart(2, '0')
    }

    setMinuteNumber(value) {
        this.minuteNumber = value
    }

    get minuteNumberStr() {
        return `${this.minuteNumber}`.padStart(2, '0')
    }

    setSecondNumber(value) {
        this.secondNumber = value
    }

    get secondNumberStr() {
        return `${this.secondNumber}`.padStart(2, '0')
    }

    setList(value) {
        this.list = value
    }


    datetimeList = [
        0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22
    ].map(hour =>
        DateTime.now().set({
            hour: hour
        }).startOf('hour')
    )

    use(datetimeList) {
        const curTime = DateTime.now();
        const curHour = curTime.hour

        const i = Math.floor(curHour / 2)
        const secKillStartTime = datetimeList[i]

        let secKillEndTime = secKillStartTime.plus({hours: 2})

        const diffObj = secKillEndTime.diff(curTime, ['seconds', 'minutes', 'hours']).toObject()
        const secondNumber = Math.floor(diffObj.seconds)
        const minuteNumber = diffObj.minutes
        const hourNumber = diffObj.hours


        this.startTime = secKillStartTime
        this.endTime = secKillEndTime
        this.hourNumber = hourNumber
        this.minuteNumber = minuteNumber
        this.secondNumber = secondNumber
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const secKillStore = new SecKillStore()

function useFetchSecKillList({setSecKillList}) {
    useEffect(() => {
        Api.secKillList({
            page: 1,
            size: 12
        }).then((list) => {
            setSecKillList(list)
        });
    }, [])
}

function useSecKill() {
    useEffect(() => {
        const timer = setInterval(() => secKillStore.use(secKillStore.datetimeList), 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);
}


const Index = ({className}) => {
    const history = useHistory()

    useFetchSecKillList({setSecKillList: v => secKillStore.setList(v)})

    const swiperRef = useRef()
    useEffect(() => {
        if (!(swiperRef.current && secKillStore.list.length)) {
            return;
        }

        const mySwiper = new Swiper(swiperRef.current, {
            slidesPerView: 3,
            spaceBetween: 15,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
        })


        //鼠标覆盖停止自动切换
        swiperRef.current.onmouseover = function () {
            mySwiper.autoplay.stop();
        }

        //鼠标离开开始自动切换
        swiperRef.current.onmouseout = function () {
            mySwiper.autoplay.start();
        }

    }, [swiperRef.current, secKillStore.list.length]);

    useSecKill()

    // 商品详情页
    const toGoodsInfo = ({goodsType, id}) => {
        const startTime = secKillStore.startTime.valueOf()
        const endTime = secKillStore.endTime.valueOf()

        MyRouterUtil.build({history}).toGoodsInfo({goodsType, id, startTime, endTime})
    }

    //  所有商品页面
    const toAllGoods = () => {
        console.log(`to all goods`)
        MyRouterUtil.build({history}).toSearchPage({})
    }

    const toNews = () => {
        history.push({
            pathname: `${MyRouter.News.realPath}`,
            search: `menuType=${NewsMenuType.NEWS}`,
        })
    }

    return (
        <div className={classNames(css.root, className)}>
            <div className={css.secKillContainer}>
                {/*秒杀信息*/}
                <div className={css.left}>
                    <div className={css.title}>
                        企业秒杀
                    </div>
                    <div className={css.floor2}>
                        <span>{secKillStore.secKillTimeStr}</span>点场，距结束
                    </div>
                    <div className={css.timeFloor}>
                        <div className={css.item}>
                            {secKillStore.hourNumberStr}
                        </div>
                        <div className={css.item}>
                            {secKillStore.minuteNumberStr}
                        </div>
                        <div className={css.item}>
                            {secKillStore.secondNumberStr}
                        </div>
                    </div>
                </div>
                {/*秒杀轮播*/}
                <div className={css.right}>
                    <div ref={swiperRef} className={classNames('swiper', css.swiper)}>
                        <div className={classNames('swiper-wrapper', css.swiperWrapper)}>
                            {
                                secKillStore.list.map((item, i) => {
                                    const {
                                        selfGoodsId,
                                        jdSkuId,
                                        pddGoodsSign,
                                        name,
                                        price,
                                        secKillPrice,
                                        mainPic,
                                        goodsType
                                    } = item

                                    const goodsTypeText = goodsTypeEnumMap.get(goodsType);
                                    let id;
                                    switch (goodsType) {
                                        case GoodsType.PDD:
                                            id = pddGoodsSign;
                                            break;
                                        case GoodsType.JD:
                                            id = jdSkuId;
                                            break;
                                        case GoodsType.SELF:
                                        default:
                                            id = selfGoodsId;
                                            break;
                                    }
                                    return (
                                        <div
                                            key={i}
                                            className={classNames('swiper-slide', css.swiperSlide)}
                                            onClick={() => {
                                                toGoodsInfo({goodsType, id})
                                            }}
                                        >
                                            <img className={css.img} src={mainPic} alt=''/>
                                            <div className={css.goodsTypeWrapper}>
                                                <span>{goodsTypeText}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className={css.allGoodsContainer}>
                <div className={css.left}>
                    <div className={css.title}>
                        全部商品
                    </div>
                    <div className={css.subTitle}>
                        海量商品尽享低价购入
                    </div>
                    <button className={css.btn} onClick={toAllGoods}>
                        <div className={css.text}>
                            查看
                        </div>
                        <img src={require('./img/block1秒杀楼层全部商品箭头右.png')} alt="" className={css.icon}/>
                    </button>
                </div>
                {/*全部商品*/}
                <div className={css.right}>
                    <img src={allGoodsImg} alt=""/>
                </div>
            </div>

            <div className={css.newsContainer}>
                <img src={require('./img/block1资讯中心背景.png')} className={css.bgImg}/>
                <div className={css.left}>
                    <div className={css.title}>资讯中心</div>
                    <div className={css.subTitle}>掌握资讯 快人一步</div>
                    <button className={css.btn} onClick={toNews}>
                        <div className={css.text}>
                            查看
                        </div>
                        <img src={require('./img/block1秒杀楼层资讯中心箭头右.png')} alt="" className={css.icon}/>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default observer(Index)